export default {
    'journal-number-automatic-or-manual': 'رقم اليومية آلي أو يدوي',
    warehouse: 'المستودع',
    add: 'إضافة',
    delete: 'حذف',
    save: 'حفظ',
    edit: 'تعديل',
    'view-invoice': 'عرض الفاتورة',
    'view-manufacturing-bond': 'عرض سند التصنيع',
    not: 'غير',
    posted: 'مُرحّل',
    'add-journal': 'إضافة يومية',
    'journal-date': 'تاريخ اليومية',
    create: 'إنشاء',
    cancel: 'إلغاء',

    'delete-entry': 'حذف قيد',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف القيد?',

    'delete-journal': 'حذف اليومية',
    'are-you-sure-you-want-to-delete-the-journal': 'هل أنت متأكد من حذف اليومية؟',
    
    'make-sure-the-data-entered-is-correct': 'تأكد من صحة البيانات المدخلة',

    headers: {
        'no': 'الرقم',
        'in-quantity': 'كمية داخلة',
        'out-quantity': 'كمية خارجة',
        'warehouse': 'المستودع',
        'material': 'المادة',
        'count': 'العدد',
        'price': 'السعر',
        'notes': 'الشرح',
        'document': 'المستند',
        'account': 'الحساب',
        'date': 'التاريخ',
    },

    'context-menu': {
        'material-statement': 'كشف مادة',
        'edit': 'تعديل',
        'delete-item': 'حذف',
    }
}